<template>
	<div class="heads">
		<div class="big-center">
			<div class="center font-top padding-tb-lg" style="border-bottom: 1px solid #E6E6E6;">
				<div class="flex align-center">
					<img src="../assets/index/4.png" style="width: 60px;height: 60px;">
					<div class="margin-left">
						<div class="text-lg text-black">正品保障</div>
						<div class="text-sm text-gray">购物无忧</div>
					</div>
				</div>
				<div class="flex align-center">
					<img src="../assets/index/2.png" style="width: 60px;height: 60px;">
					<div class="margin-left">
						<div class="text-lg text-black">很低批发</div>
						<div class="text-sm text-gray">为您精选优质品种</div>
					</div>
				</div>
				<div class="flex align-center">
					<img src="../assets/index/3.png" style="width: 60px;height: 60px;">
					<div class="margin-left">
						<div class="text-lg text-black">售后无忧</div>
						<div class="text-sm text-gray">服务至上</div>
					</div>
				</div>
				<div class="flex align-center" @click="goAbout('/helpCenterList')">
					<img src="../assets/index/1.png" style="width: 60px;height: 60px;">
					<div class="margin-left">
						<div class="text-lg text-black">帮助中心</div>
						<div class="text-sm text-gray">全面购物指南</div>
					</div>
				</div>
			</div>
			<div class="center flex justify-between align-center padding-tb-lg">
				<div class="cont left">
					<img class="logos" src="../assets/logo.png" />
					<div class="text-lg text-bold text-black">400-663-0038</div>
					<div class="text-gray">全国24小时客服热线</div>
				</div>
				<div class="flex flex-sub justify-around">
					<div class="">
						<div class="text-bold text-lg text-black">用户指南</div>
						<div class="text-gray margin-top" @click="goAbout('/helpCenterDet?id=10')">预售商品</div>
						<div class="text-gray" @click="goAbout('/helpCenterDet?id=2')">海外直邮</div>
						<div class="text-gray" @click="goAbout('/helpCenterDet?id=1')">招募创业人员</div>
					</div>
					<div class="">
						<div class="text-bold text-lg text-black">个人中心</div>
						<div class="text-gray margin-top" @click="goAbout('/helpCenterDet?id=5')">门店信息</div>
						<div class="text-gray" @click="goAbout('xiugai')">修改密码</div>
						<div class="text-gray" @click="goAbout('/order?isSelect=index&select=address')">地址管理</div>
					</div>
					<div class="">
						<div class="text-bold text-lg text-black">入驻信息</div>
						<div class="text-gray margin-top" @click="goAbout('register')">门店注册</div>
						<div class="text-gray" @click="goAbout('https://seller.hendipifa.cn/merchant')">供应商免费入驻</div>
						<div class="text-gray" @click="goAbout('/helpCenterDet?id=14')">联系客服</div>
					</div>
					<div class="">
						<div class="text-bold text-lg text-black">下单交易</div>
						<div class="text-gray margin-top" @click="goAbout('/helpCenterDet?id=5')">下单问题</div>
						<div class="text-gray" @click="goAbout('/helpCenterDet?id=6')">电脑单盖章</div>
						<div class="text-gray" @click="goAbout('/helpCenterDet?id=7')">检验报告盖章</div>
					</div>
				</div>

				<div class="flex justify-around">
					<!-- <div class="xcx">
						<img class="erweima" :src="QRcode" />
						<div class="saoma">APP下单</div>
					</div> -->
					<div class="xcx">
						<img class="erweima" src="../assets/foot/app.png" />
						<div class="saoma">扫码下载APP</div>
					</div>
				</div>
			</div>
		</div>
		<section class="copyright-section">
			<p>Copyright © 2022-2022 All Rights Reserved <a href="http://www.beian.gov.cn/">粤ICP备2021006769号-3</a>
				深圳市很低批网络科技有限公司
			</p>
		</section>
		<el-dialog title="修改密码" :visible.sync="dialogVisible" width="800px" center>
			<div style="margin-bottom: 10px;">
				<span style="width: 200px;display: inline-block;text-align: right;">旧密码：</span>
				<el-input style="width:50%;" v-model="old" type="text" placeholder="请输入旧密码"></el-input>
			</div>
			<div style="margin-bottom: 10px;">
				<span style="width: 200px;display: inline-block;text-align: right;">新密码：</span>
				<el-input style="width:50%;" v-model="pwd" type="password" placeholder="请输入新密码"></el-input>
			</div>
			<div style="margin-bottom: 10px;">
				<span style="width: 200px;display: inline-block;text-align: right;">再次输入新密码：</span>
				<el-input style="width:50%;" v-model="pwd2" type="password" placeholder="请再次输入新密码"></el-input>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="refuseto()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Foots',
		data() {
			return {
				QRcode: '../assets/foot/xcx.png',
				company: '深圳市很低批网络科技有限公司',
				address: '深圳市龙华区观湖街道环观南路德盛昌大厦7楼',
				//weixin: 'maxdlln',
				//beianhao: '粤ICP备2021006769号',
				userId: '',
				dialogVisible: false,
				old: '',
				pwd: '',
				pwd2: '',
			}
		},
		methods: {
			goAbout(url) {
				this.userId = this.$cookie.get('userId')

				if (url == 'https://seller.hendipifa.cn/merchant') {
					window.location.href = url
				} else if (url == 'xiugai') {
					if (this.userId) {
						this.old = ''
						this.pwd = ''
						this.pwd2 = ''
						this.dialogVisible = true
					} else {
						window.open('/', '_blank');
					}
				} else {
					window.open('/#' + url, '_blank');
				}

			},
			/* getCode() {
				this.$http({
					url: this.$http.adornUrl('/common/type/280'), //小程序二维码
					method: 'get',
				}).then(({
					data
				}) => {
					window.localStorage.setItem("QRcode", data.data.value);
					this.QRcode = data.data.value
				})
				this.$http({
					url: this.$http.adornUrl('/common/type/281'), //app下载地址
					method: 'get',
				}).then(({
					data
				}) => {
					window.localStorage.setItem("downcode", data.data.value);
					this.downcode = data.data.value
				})
				this.$http({
					url: this.$http.adornUrl('/common/type/282'), //公司名称
					method: 'get',
				}).then(({
					data
				}) => {
					this.company = data.data.value
				})
				this.$http({
					url: this.$http.adornUrl('/common/type/283'), //公司地址
					method: 'get',
				}).then(({
					data
				}) => {
					this.address = data.data.value
				})

				this.$http({
					url: this.$http.adornUrl('/common/type/284'), //备案号
					method: 'get',
				}).then(({
					data
				}) => {
					this.beianhao = data.data.value
				})

				this.$http({
					url: this.$http.adornUrl('/common/type/44'), //微信号
					method: 'get',
				}).then(({
					data
				}) => {
					this.weixin = data.data.value
				})
			}, */
			// 修改密码
			refuseto() {
				if (this.pwd == '') {
					this.$notify({
						title: '提示',
						duration: 1800,
						message: '请输入新密码',
						type: 'warning'
					});
					return
				}
				if (this.pwd2 == '') {
					this.$notify({
						title: '提示',
						duration: 1800,
						message: '请再次输入新密码',
						type: 'warning'
					});
					return
				}
				if (this.pwd2 != this.pwd) {
					this.$notify({
						title: '提示',
						duration: 1800,
						message: '两次输入的密码不一致，请核对后重新输入',
						type: 'warning'
					});
					return
				}
				this.$http({
					url: this.$http.adornUrl('/user/updatePwd'), //小程序二维码
					method: 'post',
					data: this.$http.adornData({
						'old': this.old,
						'pwd': this.pwd,
						'userId': this.userId
					})
				}).then(({
					data
				}) => {
					if (data.status == 0) {
						this.$notify({
							title: '提示',
							duration: 1800,
							message: '修改成功，请重新登陆',
							type: 'success',
							onClose: () => {
								this.$cookie.set('uuid', '')
								this.$cookie.set('userId', '')
								this.$cookie.set('image_url', '')
								this.$cookie.set('nickName', '')
								this.$cookie.set('phone', '')
								this.$cookie.set("is_pass", '')

								this.$router.push({
									path: '/login'
								})
							}
						});

					} else {
						this.$notify({
							title: '提示',
							duration: 1800,
							message: data.msg,
							type: 'warning'
						});
						return
					}
				})
			}

		}
	}
</script>
<style scoped="scoped">
	.big-center {
		width: 100%;
		/* height: 290px; */
		line-height: 24px;
		font-size: 14px;
		background: #FFFFFF;
		padding: 20px 0;
	}

	.center {
		width: 1000px;
		margin: 0 auto;
	}

	.font-top {
		display: flex;
		justify-content: space-between;
	}

	.flex {
		display: flex;

	}

	.align-center {
		align-items: center;
	}

	.space-between {
		justify-content: space-between;
	}

	.text-black {
		color: #333333;
	}

	.text-gray {
		color: #999999;
		cursor: pointer;
	}

	.text-sm {
		font-size: 12px;
	}

	.text-df {
		font-size: 14px;
	}

	.text-lg {
		font-size: 16px;
	}

	.text-xl {
		font-size: 18px;
	}


	.cont {
		display: inline-block;
		font-size: 14px;
	}

	.left {
		/* width: 25%; */
		text-align: left;
	}

	.left img {
		width: 217px;
		height: 56px;
	}

	.conter {
		text-align: left;
		width: 30%;
		line-height: 40px;
	}

	.names {
		font-size: 20px;
	}

	.xcx {
		margin: 0 10px;
	}

	.erweima {
		width: 80px;
		height: 80px;
	}

	.saoma {
		text-align: center;
	}

	.copyright-section {
		color: #999999;
		padding: 10px 0;
		font-size: 10px;
		text-align: center;
		background: #34495E;
	}

	.copyright-section a {
		color: #999999;
	}

	.margin-left {
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/foots.vue